// Generated by CoffeeScript 2.7.0
var PushPackagePayload;

import Paginator from 'trunks/vue/admin/components/paginator.js';

export default PushPackagePayload = Vue.extend({
  components: {
    paginator: Paginator
  },
  props: {
    resourceUrl: {
      type: String
    }
  },
  data: function() {
    return {
      payloadList: [],
      pushPackageName: ''
    };
  },
  template: `<div class="payload-list-container main-content-list-container">
  <div class="list-title mb-6">{{ pushPackageName }}</div>
  <div class="list-content">
    <div class="datable-table">
      <div class="table-responsive payload-table">
        <table class="table table-noborder table-striped">
          <thead>
            <tr>
              <th>序号</th>
              <th>推送方式</th>
              <th>推送时间</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(payload, index) in payloadList ">
              <tr class="table-row">
                <td>
                  <div class="row-cell text-ellipsis">{{ index + 1 }}</div>
                </td>
                <td>
                  <div class="row-cell text-ellipsis">{{ payload.type_text }}</div>
                </td>
                <td>
                  <div class="row-cell text-ellipsis">
                    <span>系统将</span><span v-if="index > 0">在上一次推送结束后</span>
                    <span v-if="payload.time.hour > 0"><strong>{{payload.time.hour}}小时</strong></span>
                    <span v-if="payload.time.minute > 0"><strong>{{payload.time.minute}}分钟</strong></span>
                    <span v-if="payload.time.hour == 0 && payload.time.minute == 0"><strong>立刻</strong></span>
                    <span>推送</span>
                  </div>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>`,
  created: function() {
    return Turbolinks.clearCache();
  },
  watch: {
    resourceUrl: {
      handler: function() {
        return this.doRequest();
      },
      immediate: true
    }
  },
  methods: {
    doRequest: function() {
      return Skylark.Libs.Ajax.get(this.resourceUrl, {
        responseType: 'json',
        success: (data) => {
          this.pushPackageName = data.name;
          return this.payloadList = this._parsePayloadList(data.payload);
        }
      });
    },
    _parsePayloadList: function(data) {
      return _.map(data, (payload, index) => {
        payload.time = this._parsePushTime(payload.waiting);
        switch (payload.push_type) {
          case 'Push::CustomMessage':
            payload.type_text = '微信';
            break;
          case 'Push::Sms':
            payload.type_text = '短信';
            break;
          case 'Push::Call':
            payload.type_text = '电话';
        }
        return payload;
      });
    },
    _parsePushTime: function(time) {
      return {
        hour: parseInt(time / 60),
        minute: time % 60
      };
    }
  }
});
